import Layout from "@components/Layout";
import WrapperProvider from "@providers/WrapperProvider";
import StoryContainer from "@containers/StoryContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import _ from "lodash";
import { getServer } from "@translations/next";
import StoryArticleService from "@services/StoryArticleService";
import StoryCategoryService from "@services/StoryCategoryService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <StoryContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  const resCategory = await StoryCategoryService.find({
    locale,
    populate: "deep",
  });
  const res = await StoryArticleService.find({
    populate: ["category", "thumbnail"],
    page: 1,
    pageSize: 6,
    locale,
    filters: {
      hotels: {
        slug: {
          $eq: "amanaki-boutique-saigon",
        },
      },
    },
    sort: 'publishedAt:desc'
  });
  const footerData = await FooterService.fetchByHotel("amanaki-boutique-saigon", locale);
  return {
    hotel: "amanaki-boutique-saigon",
    categories: _.get(resCategory, "data", null),
    articles: _.get(res, "data", []),
    footerData,
  };
});
